<template>
	<div class="gnb on">
		<div class="inner">
      <div class="user_info">
				<span>{{userName}}</span> 대리점님
				<div style="float: right; margin-right: 50px;">
					<a href="javascript:void(0)" @click="logout">로그아웃</a>
				</div>
			</div>
			<div class="passresest">
				<a href="javascript:void(0);" class="button white pt5 pb5" @click="initPassword">
					<span>비밀번호 초기화</span>
				</a>
			</div>
			<div class="gnb_menu">
				<ul>
					<li v-for="(a, i) in menuList" v-bind:key="a.menu + '_' + i" @click="clkMenu($event, i)">{{a.menu}}</li>
				</ul>
			</div>
		</div>
    <initPasswordPopup />
		<a href="javascript:void(0);" class="close" title="close" @click="hideSubMenu">close</a>
	</div>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import InitPasswordPopup from '../views/common/InitPasswordPopup.vue'

export default {
	name: 'gnb',
  components: { InitPasswordPopup },
  data () {
    return {
			menuList: []
    }
	},
	methods: {
    hideSubMenu () {
      this.$emit('childs-event');
    },
		initPassword () {
			this.$modal.show('initPasswordPopup');
		},
		clkMenu(e, i) {
			router.push(this.menuList[i].action);
			this.hideSubMenu();
		},
		logout() {
      window.$store
        .dispatch('Login/logout')
        .then(() => {
          router.push('/');
					this.hideSubMenu();
        });
		}
	},
	mounted: function () {
		this.$nextTick(function() {
			this.menuList = [
				{menu:'주문통합뷰', action: '/order/OrderStatus'},
				{menu:'매출마감 실적', action: '/report/SellingClosingActualResult'},
				{menu:'반품현황', action: '/returning/ReturningStatus'},
				{menu:'공지사항', action: '/notice/Notice'},
				{menu:'상품조회', action: '/product/ProductInquiry'},
			];
		});
	},
	computed: {
		// 사용자명
		userName() {
			return window.$store.getters['Login/getUserName']
		}
	}

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/GNB.vue